import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { apiMiddleware } from 'redux-api-middleware';
import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import createRootReducer from './reducers';
import authMiddleware from './middleware/auth';
import checkSessionMiddleware from './middleware/checkSession';
import uiMiddleware from './middleware/ui';
import digitizedContractsMiddleware from './middleware/digitizedContracts';
import uploadUsersMiddleware from './middleware/uploadUsers';
import productsMiddleware from './middleware/products';
import bundlesMiddleware from './middleware/bundles';
import requestLogger from './middleware/logger';

const history = createBrowserHistory();

export const getHistory = () => history;

const middlewares = [
  routerMiddleware(history),
  authMiddleware,
  requestLogger,
  apiMiddleware,
  thunk,
  checkSessionMiddleware,
  uiMiddleware,
  uploadUsersMiddleware,
  digitizedContractsMiddleware,
  productsMiddleware,
  bundlesMiddleware,
];

const store = (preloadedState = {}) =>
  createStore(createRootReducer(history), preloadedState, applyMiddleware(...middlewares));

export default store;
